import { Box, Grid, Stack } from "@mui/material";
import ContactUsForm from "./ContactUsForm";

const ContactUs = ({ id, newTheme }) => {
  return (
    <Stack
      sx={{
        maxWidth: 1000,
        mx: "auto",
        width: "100%",
        flexDirection: {
          xs: "column-reverse",
          md: "row",
        },
        m: { xs: 0, lg: 6 },
        my: { xs: 3 },
        gap: { xs: 2, lg: 2 },
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack spacing={2} justifyContent="center">
        <Stack width={"100%"} height={"100%"} alignItems="center">
          <Box sx={{ width: "100%", height: "100%" }}>
            <img
              src="/static/images/ContactUs.png"
              alt="contact us"
              width={392}
              height={540}
              style={{
                borderRadius: "16px",
                // , margin: "0 auto"
              }}
            />
          </Box>
        </Stack>
      </Stack>

      <Stack justifyContent="center">
        {/* موقتا غیر فعال */}
        {/* <ContactUsForm newTheme={newTheme} /> */}
      </Stack>
    </Stack>
  );
};

export default ContactUs;

//  <Stack id={id} spacing={6} textAlign="center" justifyContent="center" py={6}>
//    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
//      <Grid
//        container
//        rowSpacing={2}
//        columnSpacing={{ xs: 1, sm: 1, md: 2 }}
//        justifyContent="center"
//        alignItems="center"
//      >
//        <Grid item sm={12} md={6} sx={{ display: { xs: "none", md: "flex" } }}>
//          <Stack width={"100%"} height={"100%"} alignItems="center">
//            <Box sx={{ width: "100%", height: "100%" }}>
//              <img
//                src="/static/images/ContactUs.png"
//                alt="contact us"
//                width={584}
//                height={528}
//                style={{ borderRadius: "16px", margin: "0 auto" }}
//              />
//            </Box>
//          </Stack>
//        </Grid>
//        <Grid item sm={12} md={6}>
//          {/* <ContactUsForm /> */}
//        </Grid>
//      </Grid>
//    </Stack>
//  </Stack>;
